document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('.text-opacity-animation');
    if (!containers.length) return;

    const LETTER_DELAY = 35;
    const TRANSITION_MS = 900;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const wrapLetters = (root) => {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
            acceptNode: (node) => {
                if (!node.nodeValue || !node.nodeValue.length) return NodeFilter.FILTER_REJECT;
                return NodeFilter.FILTER_ACCEPT;
            }
        });

        const textNodes = [];
        let current;
        while ((current = walker.nextNode())) textNodes.push(current);

        textNodes.forEach((textNode) => {
            const text = textNode.nodeValue;
            if (!text.trim()) return;

            const frag = document.createDocumentFragment();
            const chars = Array.from(text);
            let wordSpan = null;

            chars.forEach((char) => {
                if (/\s/.test(char)) {
                    wordSpan = null;
                    frag.appendChild(document.createTextNode(char));
                    return;
                }
                if (!wordSpan) {
                    wordSpan = document.createElement('span');
                    wordSpan.className = 'toa-word';
                    frag.appendChild(wordSpan);
                }
                const letter = document.createElement('span');
                letter.className = 'toa-letter';
                letter.textContent = char;
                wordSpan.appendChild(letter);
            });

            textNode.parentNode.replaceChild(frag, textNode);
        });
    };

    const animate = (container) => {
        const letters = container.querySelectorAll('.toa-letter');
        if (!letters.length) {
            container.classList.add('is-done');
            return;
        }

        if (prefersReducedMotion) {
            container.classList.add('is-done');
            return;
        }

        letters.forEach((letter, index) => {
            letter.style.transitionDelay = `${index * LETTER_DELAY}ms`;
        });

        requestAnimationFrame(() => {
            container.classList.add('is-animating');
        });

        const totalDuration = letters.length * LETTER_DELAY + TRANSITION_MS;
        setTimeout(() => {
            container.classList.add('is-done');
            letters.forEach((letter) => {
                letter.style.transitionDelay = '';
            });
        }, totalDuration);
    };

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const container = entry.target;
            obs.unobserve(container);
            animate(container);
        });
    }, { threshold: 0.6, rootMargin: '0px 0px -15% 0px' });

    containers.forEach((container) => {
        wrapLetters(container);
        observer.observe(container);
    });
});
